import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@core/pipes/translate.pipe';
import { TranslationService } from '@core/services/translation.service';
import { AuthService } from '@modules/auth/services/auth.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    RouterLink,
    FormsModule,
    SelectModule,
    AsyncPipe,
    TranslatePipe,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  builder = inject(FormBuilder);
  forgotPassForm!: FormGroup;

  constructor(
    public authService: AuthService,
    public translateService: TranslationService,
    private messageService: MessageService,
  ) {
    this.forgotPassForm = this.builder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  switchLang(lang: string) {
    this.translateService.setLanguage(lang);
  }

  onForgotPassword() {
    if (!this.forgotPassForm.valid) {
      this.forgotPassForm.markAllAsTouched();
      return;
    }

    this.authService.forgotPassword(this.forgotPassForm.value).subscribe({
      next: (res) => {
        if (res && res['success']) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res?.message || 'Email sent successfully',
          });
        }
      },
    });
  }
}
